export default "__VITE_ASSET__T$TWrbX7dYuHzqRsqeczIQ__"